import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid } from 'src/components';
import BaseComponent from 'src/core/base.component';
import { translate } from 'src/i18n/tHelper';
import KurumBonusTanimlariTestBazliListesi from './Liste';
import KurumBonusTanimlariTestBazliEkle from './Ekle';
import { useAppSelector } from 'src/store';

const translatePath = "pages|kurumBonusTanimlari";
const KurumBonusTanimlariTestBazli = (): JSX.Element => {
    const state = useAppSelector(s => s.kurumBonusTanimlariTestBazli);
    return (
        <>
            <Helmet><title>{translate(translatePath, "Kurum Bonus Tanımları Test Bazlı")}</title></Helmet>
            <BaseComponent>
                <Grid container>
                    <Grid item>
                        <KurumBonusTanimlariTestBazliListesi />
                    </Grid>
                </Grid>
            </BaseComponent>
            {state.open && <KurumBonusTanimlariTestBazliEkle />}
        </>
    );
};

export default KurumBonusTanimlariTestBazli;